//inspiration : https://jobs.coxenterprises.com/en/jobs/r202562783/lead-software-engineer/

import React, { useEffect, useState } from "react";
import Form from "../Form";

function SoftwareDeveloper() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [showModal, setShowModal] = useState(false);
  const isMobile = window.innerWidth <= 768;

  // Bootstrap 5 modal backdrop fix for React
  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
      const backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop fade show";
      backdrop.style.zIndex = 1050;
      backdrop.id = "custom-bs5-backdrop";
      document.body.appendChild(backdrop);
    } else {
      document.body.classList.remove("modal-open");
      const backdrop = document.getElementById("custom-bs5-backdrop");
      if (backdrop) document.body.removeChild(backdrop);
    }
    return () => {
      document.body.classList.remove("modal-open");
      const backdrop = document.getElementById("custom-bs5-backdrop");
      if (backdrop) document.body.removeChild(backdrop);
    };
  }, [showModal]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f7fafd",
        fontFamily: "Prompt, sans-serif",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: "stretch",
      }}
    >
      {/* Bootstrap Modal */}
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.3)",
            zIndex: 1060,
          }}
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
            style={{
              maxWidth: 1500,
              width: "90%",
              height: "auto",
              borderRadius: 16,
            }}
          >
            <div
              className="modal-content"
              style={{ borderRadius: 16, minHeight: 400 }}
            >
              <div
                className="modal-header"
                style={{ borderBottom: "1px solid #e0e0e0" }}
              >
                <h5 className="modal-title">สมัครฝึกงาน Software Developer</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ padding: 0 }}>
                <Form defaultPosition="Software Developer" />
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Left Section */}
      <div
        style={{
          flex: 1,
          padding: isMobile ? "20px 20px 0 20px" : "72px 0 0 150px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        {/* Breadcrumb */}
        <div
          style={{
            fontSize: isMobile ? 14 : 16,
            color: "#7a8ca3",
            marginBottom: isMobile ? 30 : 50,
            marginTop: isMobile ? 20 : 50,
          }}
        >
          <a href="/" style={{ color: "#7a8ca3", textDecoration: "none" }}>
            Home
          </a>{" "}
          /{" "}
          <a
            href="/careers"
            style={{ color: "#7a8ca3", textDecoration: "none" }}
          >
            Careers
          </a>{" "}
          /{" "}
          <span style={{ color: "#7a8ca3" }}>Software Developer (Intern)</span>
        </div>
        {/* Job Info */}
        <div
          style={{
            fontSize: isMobile ? 28 : 44,
            fontWeight: 700,
            color: "#222d3a",
            marginBottom: 32,
            lineHeight: isMobile ? 1.3 : 1.2,
          }}
        >
          Software Developer (Intern)
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: isMobile ? 12 : 18,
            marginBottom: 32,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ fontSize: isMobile ? 18 : 22 }}>📍</span>
            <span style={{ fontSize: isMobile ? 14 : 20, color: "#222d3a" }}>
              677/5 ซอย ลาดพร้าว 48 แขวงสามเสนนอก เขตห้วยขวาง กรุงเทพมหานคร
              10310
            </span>
          </div>
          <div
            style={{
              display: "flex",
              gap: 12,
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "flex-start" : "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: isMobile ? 18 : 22 }}>📄</span>
              <span style={{ fontSize: isMobile ? 14 : 20, color: "#222d3a" }}>
                ระดับ : นักศึกษาฝึกงาน
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginLeft: isMobile ? 0 : 24,
              }}
            >
              <span style={{ fontSize: isMobile ? 18 : 22 }}>💼</span>
              <span style={{ fontSize: isMobile ? 14 : 20, color: "#222d3a" }}>
                หมวดหมู่งาน: เทคโนโลยี
              </span>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ fontSize: isMobile ? 18 : 22 }}>🕒</span>
            <span style={{ fontSize: isMobile ? 14 : 20, color: "#222d3a" }}>
              จันทร์ - ศุกร์ : 8:30 - 17:30
            </span>
          </div>
        </div>
        {/* Apply Button & Icons */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile ? 16 : 24,
            marginBottom: 32,
            flexWrap: "wrap",
          }}
        >
          <button
            style={{
              background: "#19b6f7",
              color: "#fff",
              fontSize: isMobile ? 18 : 22,
              fontWeight: 600,
              border: "none",
              borderRadius: 32,
              padding: isMobile ? "14px 36px" : "18px 54px",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              letterSpacing: 1,
            }}
            onClick={() => setShowModal(true)}
          >
            สมัครเลย
          </button>
        </div>
        {/* Footer Info */}
        <div
          style={{
            fontSize: isMobile ? 14 : 16,
            color: "#1a232c",
            marginTop: 32,
            lineHeight: isMobile ? 1.5 : 1.2,
          }}
        >
          แผนก: IT &nbsp; | &nbsp; ประเภท: Full time, Day &nbsp; | &nbsp; ลางาน:
          5% ของเวลาทำงาน
        </div>
        {/* Job Description Example */}
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            padding: isMobile ? "20px 16px" : "32px 36px",
            marginTop: 40,
            marginBottom: 40,
            maxWidth: isMobile ? "100%" : 1000,
            color: "#222d3a",
            fontSize: isMobile ? 16 : 18,
            resize: "both",
            overflow: "auto",
            minWidth: isMobile ? "auto" : 320,
            minHeight: 200,
          }}
        >
          <div
            style={{
              paddingLeft: isMobile ? 12 : 24,
              marginBottom: 0,
              marginTop: isMobile ? 12 : 24,
            }}
          >
            <div style={{ marginBottom: 8 }}>
              <strong>หน้าที่และความรับผิดชอบ</strong>
              <ul>
                <li>
                  มีส่วนร่วมในการพัฒนาซอฟต์แวร์: ช่วยทีมในการออกแบบ พัฒนา
                  และทดสอบฟีเจอร์ใหม่ๆ สำหรับแอปพลิเคชันหรือระบบต่างๆ ของบริษัท
                </li>
                <li>
                  แก้ไขข้อผิดพลาด (Bug Fixing):
                  ทำงานร่วมกับทีมเพื่อระบุและแก้ไขข้อผิดพลาดที่เกิดขึ้นในซอฟต์แวร์
                </li>
                <li>
                  เขียนโค้ดที่มีคุณภาพ: พัฒนาโค้ดที่สะอาด มีประสิทธิภาพ
                  และสามารถดูแลรักษาได้ง่าย
                </li>
                <li>
                  ทำความเข้าใจความต้องการของผู้ใช้งาน:
                  เรียนรู้การวิเคราะห์และตีความความต้องการทางธุรกิจให้เป็นข้อกำหนดทางเทคนิค{" "}
                </li>
                <li>
                  เรียนรู้และใช้งานเทคโนโลยีใหม่ๆ: ทำความคุ้นเคยกับ Frameworks,
                  Libraries และเครื่องมือต่างๆ ที่ใช้ในการพัฒนาซอฟต์แวร์
                </li>
                <li>
                  จัดทำเอกสารประกอบ: ช่วยจัดทำเอกสารสำหรับโค้ด, APIs
                  และกระบวนการพัฒนาต่างๆ
                </li>
                <li>
                  ประสานงานกับทีมที่เกี่ยวข้อง: ทำงานร่วมกับ Product Managers,
                  UI/UX Designers และทีมอื่นๆ เพื่อส่งมอบผลิตภัณฑ์ที่มีคุณภาพ
                </li>
                <li>
                  งานอื่นๆ ที่ได้รับมอบหมายจากหัวหน้างาน:
                  เรียนรู้และสนับสนุนงานที่เกี่ยวข้องกับการพัฒนาซอฟต์แวร์ตามความเหมาะสม
                </li>
              </ul>
            </div>
            <div style={{ marginBottom: 8 }}>
              <strong>คุณสมบัติ</strong>
              <ul>
                <li>
                  กำลังศึกษาอยู่ในระดับปริญญาตรี: สาขาวิทยาการคอมพิวเตอร์,
                  วิศวกรรมซอฟต์แวร์, เทคโนโลยีสารสนเทศ หรือสาขาอื่น ๆ
                  ที่เกี่ยวข้อง
                </li>
                <li>
                  มีความรู้พื้นฐานด้านการเขียนโปรแกรม:
                  สามารถเขียนโปรแกรมได้อย่างน้อย 1 ภาษา เช่น Python, Java, C#,
                  JavaScript หรืออื่นๆ
                </li>
                <li>
                  เข้าใจหลักการพื้นฐานของการพัฒนาซอฟต์แวร์: เช่น Object-Oriented
                  Programming (OOP), Data Structures และ Algorithms
                </li>
                <li>
                  สนใจในการเรียนรู้และพัฒนาอย่างต่อเนื่อง:
                  กระตือรือร้นที่จะศึกษาเทคโนโลยีใหม่ๆ
                  และปรับปรุงทักษะการเขียนโค้ดของตนเอง
                </li>
                <li>
                  มีทักษะในการแก้ไขปัญหา (Problem-solving skills):
                  สามารถคิดวิเคราะห์และหาวิธีแก้ไขปัญหาได้อย่างมีเหตุผล
                </li>
                <li>
                  สามารถสื่อสารและทำงานร่วมกับผู้อื่นได้ดี:
                  เป็นผู้ที่มีทัศนคติที่ดีและพร้อมเรียนรู้
                </li>
                <li>
                  มีความรับผิดชอบและตรงต่อเวลา:
                  มุ่งมั่นในการทำงานที่ได้รับมอบหมาย
                </li>
                <li>
                  หากมีประสบการณ์: การเข้าร่วมโปรเจกต์ส่วนตัว,
                  โปรเจกต์ในชั้นเรียน หรือมีผลงาน (Portfolio)
                  ที่แสดงถึงความสามารถในการเขียนโค้ด จะได้รับการพิจารณาเป็นพิเศษ
                </li>
              </ul>
            </div>
            <div style={{ marginBottom: 8 }}>
              <strong>สวัสดิการ/ผลตอบแทน</strong>
              <ul>
                <li>เบี้ยเลี้ยง/ค่าตอบแทนระหว่างฝึกงาน</li>
                <li>
                  ประสบการณ์การทำงานจริง กับทีม Software Developer
                  ที่มีประสบการณ์
                </li>
                <li>
                  โอกาสในการเรียนรู้และพัฒนา
                  ทักษะด้านการพัฒนาซอฟต์แวร์ที่เป็นที่ต้องการในตลาด
                </li>
                <li>คำแนะนำและการดูแลอย่างใกล้ชิด จากพี่เลี้ยง</li>
                <li>ใบรับรองการฝึกงาน หลังจบโครงการ</li>
              </ul>
            </div>
            <div style={{ marginBottom: 8 }}>
              <strong>วิธีการสมัคร</strong> กรุณาส่ง Resume/CV และ Portfolio
              (ถ้ามี) พร้อมข้อมูลการติดต่อของคุณ มาที่ oaoffice@ornthai.com
              <br />
              หรือสมัครผ่านช่องทางสมัครงานของบริษัท
              <br />
              สอบถามรายละเอียดเพิ่มเติมได้ที่ โทร 02-276-9968 หรือ Line :
              @443namoj
            </div>
            <div style={{ marginBottom: 8 }}>
              <strong>หมายเหตุ:</strong> เปิดรับสมัครตั้งแต่วันนี้เป็นต้นไป
            </div>
          </div>
        </div>
      </div>
      {/* Right Section (Image + Similar Jobs) */}
      <div
        style={{
          flex: isMobile ? "none" : "0 0 30%",
          minWidth: isMobile ? "auto" : 400,
          height: "auto",
          position: isMobile ? "relative" : "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "flex-start",
          background: "none",
          overflow: "visible",
          gap: isMobile ? 24 : 32,
          marginTop: isMobile ? 32 : 0, // เพิ่ม marginTop สำหรับ mobile
          order: 2, // ให้ Right Section อยู่ล่างสุดเสมอ
        }}
      >
        <img
          src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=900&q=80"
          alt="Job Visual"
          style={{
            position: isMobile ? "relative" : "absolute",
            right: 0,
            top: isMobile ? 0 : 100,
            width: "100%",
            height: isMobile ? 300 : 400,
            objectFit: "cover",
            borderTopRightRadius: 0,
            borderTopLeftRadius: isMobile ? 8 : 150,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 8,
            minHeight: isMobile ? 300 : 470,
            maxHeight: isMobile ? 300 : 520,
            zIndex: 1,
          }}
        />
        {/* Similar Jobs */}
        <div
          style={{
            marginTop: isMobile ? 24 : 640,
            marginRight: isMobile ? 0 : "10vh",
            width: isMobile ? "100%" : "50vh",
            background: "#eaf1fa",
            borderRadius: 20,
            padding: isMobile ? 16 : 28,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              fontSize: isMobile ? 20 : 24,
              fontWeight: 700,
              color: "#222d3a",
              marginBottom: isMobile ? 16 : 24,
            }}
          >
            งานที่คล้ายกัน
          </div>
          {/* Job Card 1 */}
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: isMobile ? 12 : 18,
              marginBottom: 16,
              boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <a
              href="/careers/data-engineering"
              style={{ textDecoration: "none", color: "#222d3a" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: 600, fontSize: isMobile ? 16 : 18 }}>
                  Data Engineer
                </span>
                <span
                  style={{ fontSize: isMobile ? 22 : 26, color: "#7a8ca3" }}
                >
                  ☆
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  fontSize: isMobile ? 13 : 16,
                  color: "#222d3a",
                }}
              >
                <span>📍 กรุงเทพฯ</span>
                <span>💼 จันทร์-ศุกร์</span>
              </div>
            </a>
          </div>
          {/* Job Card 2 */}
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: isMobile ? 12 : 18,
              marginBottom: 16,
              boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <a
              href="/careers/it-support"
              style={{ textDecoration: "none", color: "#222d3a" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: 600, fontSize: isMobile ? 16 : 18 }}>
                  IT-Support
                </span>
                <span
                  style={{ fontSize: isMobile ? 22 : 26, color: "#7a8ca3" }}
                >
                  ☆
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  fontSize: isMobile ? 13 : 16,
                  color: "#222d3a",
                }}
              >
                <span>📍 กรุงเทพฯ</span>
                <span>💼 จันทร์-ศุกร์</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SoftwareDeveloper;
